import attendeeStatuses from 'constants/attendee-statuses';

export function convertAttendeeIdsToAttendees(assigneeIds) {

  const attendees = [];

  for (let assigneeId of assigneeIds) {

    attendees.push({
      startupUserId: assigneeId,
      status: attendeeStatuses.PENDING
    });

  }

  return attendees;

}